import { Col, Form, Row, Select, Spin, Table } from "antd";
import React, { useEffect, useState } from "react";
import { columns } from "./config";
import { ListActionButton, Notification } from "components/common";
import { receiveService } from "api";
import { useAppSelector } from "redux/hooks";
import { tabKeys } from "types/enums";

const ConfigCatalog = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [form] = Form.useForm();
  const handleRemoveAccount = async (id) => {
    await receiveService.deleteLinkAccount(id);
    getAllList();
    Notification("success", "Huỷ bỏ liên kết tài khoản thành công");
    try {
    } catch (error) {
      Notification(
        "error",
        error.response.data ?? "Huỷ bỏ liên kết tài khoản không thành công"
      );
    }
  };
  const tabkey = useAppSelector((e) => e.common.activeTab);
  columns.find((e) => e.dataIndex === "actions").render = (v, r: any) => (
    <ListActionButton
      titlePopupConfirm={"Bạn có muốn huỷ bỏ liên kết?"}
      deleteFunction={() => handleRemoveAccount(r.id)}
    />
  );
  const handleChange = async (e: Element) => {
    setLoading(true);
    try {
      if (!e) {
        setLoading(false);
        return;
      } else {
        await receiveService.postLinkAccount({
          userRequest: localStorage.getItem("username"),
          userMapping: e,
        });
        getAllList();
        Notification("success", "Liên kết tài khoản thành công");
        setLoading(false);
        form.resetFields();
      }
    } catch (error) {
      console.log("🚀 ~ handleChange ~ error:", error);
      Notification(
        "error",
        error.response.data ?? "Liên kết tài khoản không thành công"
      );
      setLoading(false);
    }
  };

  const getAllList = async () => {
    try {
      const res = await receiveService.getLinkAccount();
      setData(res);
    } catch (error) {
      Notification(
        "error",
        error.response.data ?? "Lấy danh sách không thành công"
      );
    }
  };

  useEffect(() => {
    if (tabkey === tabKeys.RECEIVE.CONFIG_CATALOG) {
      getAllList();
    } else {
      form.resetFields();
    }
  }, [tabkey]);
  return (
    <Spin spinning={loading}>
      <Row className="container" gutter={32}>
        <Col span={4}>Thiết bị ký: </Col>
        <Col span={8}>
          <Form form={form}>
            <Form.Item name={"guest"}>
              <Select
                allowClear
                style={{ width: "100%" }}
                options={[
                  { value: "guest1", label: "guest1" },
                  { value: "guest2", label: "guest2" },
                  { value: "guest3", label: "guest3" },
                ]}
                onChange={(e) => {
                  handleChange(e);
                }}
              />
            </Form.Item>
          </Form>
        </Col>
        <Col span={12}>
          <Table
            columns={columns}
            dataSource={data}
            bordered
            pagination={false}
          />
        </Col>
      </Row>
    </Spin>
  );
};

export default ConfigCatalog;
